export const initialState = {
  customers: [],
  status: 'idle',
  loading: false,
  formOpen: false, 
  customerForm: {
    name: '',
    description: '',
    id:0
  },
};
